import {
  restoreInMemoryConversation as restoreSharedInMemoryConversation,
  restorePersistedConversation as restoreSharedPersistedConversation,
  type RestoredConversation,
} from "@carousel-office/shared";
import LivePowerPointOrchestrator from "../../main/agents/orchestrator";
import {
  normalizeSearchHistory,
  rebuildSearchHistoryFromMessages,
} from "../../main/globals/global-state/searchHistory";

export type { RestoredConversation } from "@carousel-office/shared";

const restoreOptions = {
  primaryAgentType: "livePowerPointOrchestrator",
  ensurePrimaryAgentRegistered: (conversation: any) => {
    const existing = conversation.agentRegistry.getAgent("livePowerPointOrchestrator");
    if (!existing) {
      conversation.agentRegistry.registerAgent(
        "livePowerPointOrchestrator",
        new LivePowerPointOrchestrator()
      );
    }
  },
  normalizeSearchHistory,
  rebuildSearchHistoryFromMessages,
};

export async function restoreInMemoryConversation(
  conversationId: string
): Promise<RestoredConversation | null> {
  return restoreSharedInMemoryConversation(conversationId, restoreOptions);
}

export async function restorePersistedConversation(
  conversationId: string
): Promise<RestoredConversation | null> {
  return restoreSharedPersistedConversation(conversationId, restoreOptions);
}
